import React from 'react'
import { Link } from 'react-router'
import { Panel, FormGroup, ControlLabel, FormControl } from 'react-bootstrap'

import Button from '../components/Button.jsx'
import { getText } from '../lib/text'

// Copy from https://stackoverflow.com/a/901144
function getParameterByName(name, url) {
  const _url = url || window.location.href
  const _name = name.replace(/[\[\]]/g, "\\$&");
  const regex = new RegExp("[?&]" + _name + "(=([^&#]*)|&|#|$)")
  const results = regex.exec(_url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const styles = {
  panel: { margin : "40px" },
  button: { marginTop: "20px" },
  inputGroup: { marginBottom: "20px" },
  input: { maxWidth: "200px" }
}

class Login extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { username: "" }
  }

  render() {
    return (
      <Panel style={styles.panel}>
        <Panel.Body>
          <form action="/api/login" method="post">

            <FormGroup controlId="login-name">
              <ControlLabel>{getText("Nombre")}</ControlLabel>
              <FormControl
                type="text"
                name="username"
                style={styles.input}
                value={this.state.username}
                onChange={evt => this.setState({ username: evt.target.value })}
              />
            </FormGroup>

            <FormGroup controlId="login-pwd">
              <ControlLabel>{getText("Contraseña")}</ControlLabel>
              <FormControl type="password" name="password" style={styles.input} />
            </FormGroup>

            <FormControl
              name="redirect"
              style={{display: "none"}}
              value={getParameterByName("redirectTo")}
            />

            <Link
              to={`/requestpasswordreset/${this.state.username}`}
              style={{fontWeight: "bold", fontSize: "15px"}}
            >
              {getText("Olvidé mi contraseña")}
            </Link>

            <br />

            <Button type="submit" style={styles.button} glyph="log-in" bsSize="normal">
              {getText("Entrar")}
            </Button>
          </form>
        </Panel.Body>
      </Panel>
    )
  }
}

export default Login
